import { useMutation, useQueryClient } from "react-query";

import { addPriceListItem, editPriceListItem } from "./index";

export const useAddPriceListItem = () => {
  const queryClient = useQueryClient();

  return useMutation(["add-price-list-item"], addPriceListItem, {
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["get-pricelist"] });
    },
  });
};

export const useEditPriceListItem = () => {
  const queryClient = useQueryClient();

  return useMutation(["edit-price-list-item"], editPriceListItem, {
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["get-pricelist"] });
    },
  });
};
